import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';

import Select from './Select';

const useStyles = makeStyles(theme => ({}));

const PriceInput = ({ currentRefinement, refine }) => {
  const [min, setMin] = React.useState(0);
  const [max, setMax] = React.useState(0);
  return (
    <>
      <Typography>Price</Typography>
      <Select
        price={min}
        setPrice={min => {
          setMin(min);
          refine({
            ...currentRefinement,
            min: min === 0 ? undefined : min * 12,
          });
        }}
        none="No min"
      />
      <Typography>To</Typography>
      <Select
        price={max}
        setPrice={max => {
          setMax(max);
          refine({
            ...currentRefinement,
            max: max === 0 ? undefined : max * 12,
          });
        }}
        none="No max"
      />
      <div style={{ flex: 1 }} />
      <Typography></Typography>
    </>
  );
};

export default PriceInput;
